//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface ITokenServiceClient {
    login(request: TokenLoginRequestDto): Observable<ServiceResultOfResultDto>;
    getToken(command: GenerateTokenServiceCommand): Observable<ServiceResultOfResultDto>;
    getDSNAPToken(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class TokenServiceClient implements ITokenServiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    login(request: TokenLoginRequestDto): Observable<ServiceResultOfResultDto> {
        let url_ = this.baseUrl + "/api/TokenService/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceResultOfResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceResultOfResultDto>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<ServiceResultOfResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ServiceResultOfResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceResultOfResultDto>(null as any);
    }

    getToken(command: GenerateTokenServiceCommand): Observable<ServiceResultOfResultDto> {
        let url_ = this.baseUrl + "/api/TokenService/getToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceResultOfResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceResultOfResultDto>;
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<ServiceResultOfResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ServiceResultOfResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceResultOfResultDto>(null as any);
    }

    getDSNAPToken(): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenService/getDSNAPToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDSNAPToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDSNAPToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDSNAPToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

export interface IConfigurationClient {
    get(): Observable<AppConfig>;
}

@Injectable({
    providedIn: 'root'
})
export class ConfigurationClient implements IConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<AppConfig> {
        let url_ = this.baseUrl + "/api/Configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppConfig>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppConfig>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AppConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppConfig.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppConfig>(null as any);
    }
}

//export interface IWeatherForecastClient {
//    get(): Observable<WeatherForecast[]>;
//}
////export class WeatherForecastClient implements IWeatherForecastClient {
////    private http: HttpClient;
////    private baseUrl: string;
////    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

////    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
////        this.http = http;
////        this.baseUrl = baseUrl ?? "";
////    }

////    ////get(): Observable<WeatherForecast[]> {
////    ////    let url_ = this.baseUrl + "/api/WeatherForecast";
////    ////    url_ = url_.replace(/[?&]$/, "");

////    ////    let options_ : any = {
////    ////        observe: "response",
////    ////        responseType: "blob",
////    ////        headers: new HttpHeaders({
////    ////            "Accept": "application/json"
////    ////        })
////    ////    };

////    ////    return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
////    ////        return this.processGet(response_);
////    ////    })).pipe(_observableCatch((response_: any) => {
////    ////        if (response_ instanceof HttpResponseBase) {
////    ////            try {
////    ////                return this.processGet(response_ as any);
////    ////            } catch (e) {
////    ////                return _observableThrow(e) as any as Observable<WeatherForecast[]>;
////    ////            }
////    ////        } else
////    ////            return _observableThrow(response_) as any as Observable<WeatherForecast[]>;
////    ////    }));
////    ////}

////    ////protected processGet(response: HttpResponseBase): Observable<WeatherForecast[]> {
////    ////    const status = response.status;
////    ////    const responseBlob =
////    ////        response instanceof HttpResponse ? response.body :
////    ////        (response as any).error instanceof Blob ? (response as any).error : undefined;

////    ////    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
////    ////    if (status === 200) {
////    ////        return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
////    ////        let result200: any = null;
////    ////        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
////    ////        if (Array.isArray(resultData200)) {
////    ////            result200 = [] as any;
////    ////            for (let item of resultData200)
////    ////                result200!.push(WeatherForecast.fromJS(item));
////    ////        }
////    ////        else {
////    ////            result200 = null as any;
////    ////        }
////    ////        return _observableOf(result200);
////    ////        }));
////    ////    } else if (status !== 200 && status !== 204) {
////    ////        return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
////    ////        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
////    ////        }));
////    ////    }
////    ////    return _observableOf<WeatherForecast[]>(null as any);
////    ////}
////}

export class ServiceResult implements IServiceResult {
    succeeded?: boolean;
    error?: ServiceError | undefined;

    constructor(data?: IServiceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.error = _data["error"] ? ServiceError.fromJS(_data["error"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["error"] = this.error ? this.error.toJSON() : undefined as any;
        return data;
    }
}

export interface IServiceResult {
    succeeded?: boolean;
    error?: ServiceError | undefined;
}

export class ServiceResultOfResultDto extends ServiceResult implements IServiceResultOfResultDto {
    data?: ResultDto | undefined;

    constructor(data?: IServiceResultOfResultDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ResultDto.fromJS(_data["data"]) : undefined as any;
        }
    }

    static override fromJS(data: any): ServiceResultOfResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfResultDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfResultDto extends IServiceResult {
    data?: ResultDto | undefined;
}

export class ResultDto implements IResultDto {
    token?: string | undefined;
    message?: string | undefined;
    url?: string | undefined;

    constructor(data?: IResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.message = _data["message"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["message"] = this.message;
        data["url"] = this.url;
        return data;
    }
}

export interface IResultDto {
    token?: string | undefined;
    message?: string | undefined;
    url?: string | undefined;
}

export class ServiceError implements IServiceError {
    message?: string | undefined;
    code?: number;

    constructor(data?: IServiceError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ServiceError {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["code"] = this.code;
        return data;
    }
}

export interface IServiceError {
    message?: string | undefined;
    code?: number;
}

export class TokenLoginRequestDto implements ITokenLoginRequestDto {
    username?: string | undefined;
    password?: string | undefined;
    sourceRequestParams?: TokenDto | undefined;

    constructor(data?: ITokenLoginRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.sourceRequestParams = _data["sourceRequestParams"] ? TokenDto.fromJS(_data["sourceRequestParams"]) : undefined as any;
        }
    }

    static fromJS(data: any): TokenLoginRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenLoginRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["sourceRequestParams"] = this.sourceRequestParams ? this.sourceRequestParams.toJSON() : undefined as any;
        return data;
    }
}

export interface ITokenLoginRequestDto {
    username?: string | undefined;
    password?: string | undefined;
    sourceRequestParams?: TokenDto | undefined;
}

export class TokenDto implements ITokenDto {
    reDueDate?: string | undefined;
    caseNumber?: string | undefined;
    stateID?: string | undefined;
    systemUniqueID?: string | undefined;
    formLanguage?: string | undefined;
    officialFormID?: string | undefined;
    additionalParams?: KeyValuePairOfStringAndString[] | undefined;

    constructor(data?: ITokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reDueDate = _data["reDueDate"];
            this.caseNumber = _data["caseNumber"];
            this.stateID = _data["stateID"];
            this.systemUniqueID = _data["systemUniqueID"];
            this.formLanguage = _data["formLanguage"];
            this.officialFormID = _data["officialFormID"];
            if (Array.isArray(_data["additionalParams"])) {
                this.additionalParams = [] as any;
                for (let item of _data["additionalParams"])
                    this.additionalParams!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new TokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reDueDate"] = this.reDueDate;
        data["caseNumber"] = this.caseNumber;
        data["stateID"] = this.stateID;
        data["systemUniqueID"] = this.systemUniqueID;
        data["formLanguage"] = this.formLanguage;
        data["officialFormID"] = this.officialFormID;
        if (Array.isArray(this.additionalParams)) {
            data["additionalParams"] = [];
            for (let item of this.additionalParams)
                data["additionalParams"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITokenDto {
    reDueDate?: string | undefined;
    caseNumber?: string | undefined;
    stateID?: string | undefined;
    systemUniqueID?: string | undefined;
    formLanguage?: string | undefined;
    officialFormID?: string | undefined;
    additionalParams?: KeyValuePairOfStringAndString[] | undefined;
}

export class KeyValuePairOfStringAndString implements IKeyValuePairOfStringAndString {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IKeyValuePairOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfStringAndString {
    key?: string | undefined;
    value?: string | undefined;
}

export class GenerateTokenServiceCommand implements IGenerateTokenServiceCommand {
    sourceRequestParams?: TokenDto | undefined;

    constructor(data?: IGenerateTokenServiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceRequestParams = _data["sourceRequestParams"] ? TokenDto.fromJS(_data["sourceRequestParams"]) : undefined as any;
        }
    }

    static fromJS(data: any): GenerateTokenServiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateTokenServiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceRequestParams"] = this.sourceRequestParams ? this.sourceRequestParams.toJSON() : undefined as any;
        return data;
    }
}

export interface IGenerateTokenServiceCommand {
    sourceRequestParams?: TokenDto | undefined;
}

export class AppConfig implements IAppConfig {
    rentApiUrl?: string | undefined;
    formsApiUrl?: string | undefined;
    coreApiUrl?: string | undefined;
    portalApiUrl?: string | undefined;
    portalProgramID?: string | undefined;
    appealsApiUrl?: string | undefined;
    timeout_in_minutes?: number;
    portalApiKey?: string | undefined;
    environment?: string | undefined;
    rentApiKey?: string | undefined;
    appealsApiKey?: string | undefined;
    botSecretKey?: string | undefined;
    dsnapApiUrl?: string | undefined;

    constructor(data?: IAppConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rentApiUrl = _data["rentApiUrl"];
            this.formsApiUrl = _data["formsApiUrl"];
            this.coreApiUrl = _data["coreApiUrl"];
            this.portalApiUrl = _data["portalApiUrl"];
            this.portalProgramID = _data["portalProgramID"];
            this.appealsApiUrl = _data["appealsApiUrl"];
            this.timeout_in_minutes = _data["timeout_in_minutes"];
            this.portalApiKey = _data["portalApiKey"];
            this.environment = _data["environment"];
            this.rentApiKey = _data["rentApiKey"];
            this.appealsApiKey = _data["appealsApiKey"];
            this.botSecretKey = _data["botSecretKey"];
            this.dsnapApiUrl = _data["dsnapApiUrl"];
        }
    }

    static fromJS(data: any): AppConfig {
        data = typeof data === 'object' ? data : {};
        let result = new AppConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rentApiUrl"] = this.rentApiUrl;
        data["formsApiUrl"] = this.formsApiUrl;
        data["coreApiUrl"] = this.coreApiUrl;
        data["portalApiUrl"] = this.portalApiUrl;
        data["portalProgramID"] = this.portalProgramID;
        data["appealsApiUrl"] = this.appealsApiUrl;
        data["timeout_in_minutes"] = this.timeout_in_minutes;
        data["portalApiKey"] = this.portalApiKey;
        data["environment"] = this.environment;
        data["rentApiKey"] = this.rentApiKey;
        data["appealsApiKey"] = this.appealsApiKey;
        data["botSecretKey"] = this.botSecretKey;
        data["dsnapApiUrl"] = this.dsnapApiUrl;
        return data;
    }
}

export interface IAppConfig {
    rentApiUrl?: string | undefined;
    formsApiUrl?: string | undefined;
    coreApiUrl?: string | undefined;
    portalApiUrl?: string | undefined;
    portalProgramID?: string | undefined;
    appealsApiUrl?: string | undefined;
    timeout_in_minutes?: number;
    portalApiKey?: string | undefined;
    environment?: string | undefined;
    rentApiKey?: string | undefined;
    appealsApiKey?: string | undefined;
    botSecretKey?: string | undefined;
    dsnapApiUrl?: string | undefined;
}

//export class WeatherForecast implements IWeatherForecast {
//    date?: Date;
//    temperatureC?: number;
//    temperatureF?: number;
//    summary?: string | undefined;

//    constructor(data?: IWeatherForecast) {
//        if (data) {
//            for (var property in data) {
//                if (data.hasOwnProperty(property))
//                    (this as any)[property] = (data as any)[property];
//            }
//        }
//    }

//    init(_data?: any) {
//        if (_data) {
//            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
//            this.temperatureC = _data["temperatureC"];
//            this.temperatureF = _data["temperatureF"];
//            this.summary = _data["summary"];
//        }
//    }

//    static fromJS(data: any): WeatherForecast {
//        data = typeof data === 'object' ? data : {};
//        let result = new WeatherForecast();
//        result.init(data);
//        return result;
//    }

//    toJSON(data?: any) {
//        data = typeof data === 'object' ? data : {};
//        data["date"] = this.date ? this.date.toISOString() : undefined as any;
//        data["temperatureC"] = this.temperatureC;
//        data["temperatureF"] = this.temperatureF;
//        data["summary"] = this.summary;
//        return data;
//    }
//}

//export interface IWeatherForecast {
//    date?: Date;
//    temperatureC?: number;
//    temperatureF?: number;
//    summary?: string | undefined;
//}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
